// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-21b9c1d5]{width:100%;font-size:4vw;padding:1.333vw 0;text-align:center;color:#999}.text[data-v-21b9c1d5]{width:100%;padding:2.667vw 1.867vw}.text h4[data-v-21b9c1d5],.text p[data-v-21b9c1d5]{padding:1.333vw .8vw}.text p[data-v-21b9c1d5]{color:#999}.bg[data-v-21b9c1d5]{background-color:#fff9eb}", ""]);
// Exports
module.exports = exports;
